import { createSelector } from 'reselect';
import { get } from 'ravenjs/utils/lodash';

import * as authActions from 'modules/auth/actions';
import * as hrFitnessTestActions from 'modules/hrFitnessTest/actions';
import { createReducer } from 'utils/reducer';

/**
 * Initial state for the HR Assessment.
 * `selectedCompany` is null while the logged in user company is displayed.
 *
 * @type {Object}
 */
const INITIAL_STATE = {
    selectedCompany: null,
};

/**
 * Store the company whose HR Assessments are displayed.
 *
 * @method handleSetSelectedCompany
 * @param  {Object} state  The current state
 * @param  {Object} action The dispatched action
 * @return {Object}        The updated state
 */
export const handleSetSelectedCompany = (state, action) => ({
    ...state,
    selectedCompany: get(action, 'payload', null),
});

/**
 * Go back to the logged in user company.
 *
 * @method handleClearSelectedCompany
 * @param  {Object} state The current state
 * @return {Object}       The updated state
 */
export const handleClearSelectedCompany = state => ({
    ...state,
    selectedCompany: null,
});

export const handleLogout = () => INITIAL_STATE;

const reducer = createReducer(INITIAL_STATE, {
    [hrFitnessTestActions.setSelectedCompany.TRIGGER]: handleSetSelectedCompany,
    [hrFitnessTestActions.clearSelectedCompany.TRIGGER]: handleClearSelectedCompany,
    [authActions.logout.TRIGGER]: handleLogout,
});

export default reducer;

export const getHrFitnessTest = state => get(state, 'hrFitnessTest', {});

export const getSelectedCompany = createSelector([getHrFitnessTest], hrFitnessTest =>
    get(hrFitnessTest, 'selectedCompany', null)
);

export const getSelectedCompanyId = createSelector([getSelectedCompany], selectedCompany =>
    get(selectedCompany, 'companyId', null)
);
